import React, { useState, useEffect } from 'react';
import api from '../utils/api';
import { 
    CalendarMonth, 
    LocationOn, 
    AccessTime, 
    Link as LinkIcon, 
    EmojiEvents, 
    Groups,
    Person,
    ChevronLeft
} from '@mui/icons-material';
import { snackbar } from '../utils/showMessage';
import Loader from '../components/Loader';

const Retraining = () => {
    const [retrainings, setRetrainings] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchRetrainings = async () => {
            try {
                const response = await api.get('/retraining');
                setRetrainings(response.data);
            } catch (err) {
                console.error(err);
                snackbar('خطا در دریافت لیست بازآموزی‌ها');
            } finally {
                setLoading(false);
            }
        };
        fetchRetrainings();
    }, []);

    if (loading) return <Loader />;

    return (
        <div className="main-container container pb-5">
            <div className="row mb-4">
                <div className="col-12 mt-4">
                      
                    {retrainings.length === 0 ? (
                        <div className="alert alert-info text-center">دوره فعالی یافت نشد.</div>
                    ) : (
                        retrainings.map((item) => (
                            <div key={item._id} className="card shadow-sm mb-4 border-0 rounded-20 overflow-hidden">
                                {item.poster && (
                                    <img 
                                        src={`${process.env.REACT_APP_FILE_BASE_URL}/uploads/documents/${item.poster}`} 
                                        className="card-img-top" 
                                        alt={item.title} 
                                        style={{ height: '200px', objectFit: 'cover' }}
                                    />
                                )}
                                <div className="card-body">
                                    <h4 className="card-title text-primary mb-3">{item.title}</h4>
                                    
                                    <div className="row mb-2">
                                        <div className="col-6 size-12 text-secondary">
                                            <Groups sx={{ fontSize: 16, verticalAlign: 'middle' }} className="me-1" />
                                            برگزارکننده: {item.organizer}
                                        </div>
                                        <div className="col-6 size-12 text-secondary">
                                            <EmojiEvents sx={{ fontSize: 16, verticalAlign: 'middle' }} className="me-1" />
                                            امتیاز: {item.score}
                                        </div>
                                    </div>

                                    <div className="row mb-3">
                                        <div className="col-4 size-12">
                                            <CalendarMonth sx={{ fontSize: 16, verticalAlign: 'middle' }} className="text-secondary" /> {item.date}
                                        </div>
                                        <div className="col-4 size-12">
                                            <AccessTime sx={{ fontSize: 16, verticalAlign: 'middle' }} className="text-secondary" /> {item.time}
                                        </div>
                                        <div className="col-4 size-12">
                                            <LocationOn sx={{ fontSize: 16, verticalAlign: 'middle' }} className="text-secondary" /> {item.location}
                                        </div>
                                    </div>

                                    <div className="mb-3">
                                        <p className="size-12 fw-bold mb-1">گروه‌های هدف:</p>
                                        <div className="d-flex flex-wrap gap-2">
                                            {item.targetGroups?.map(group => (
                                                <span key={group._id} className="badge bg-light text-primary border">{group.title}</span>
                                            ))}
                                        </div>
                                    </div>

                                    {item.speakers && item.speakers.length > 0 && (
                                        <div className="mb-4">
                                            <p className="size-12 fw-bold mb-2">سخنرانان:</p>
                                            <div className="row">
                                                {item.speakers.map((speaker, index) => (
                                                    <div key={index} className="col-12 mb-2 d-flex align-items-center">
                                                        <figure className="avatar avatar-40 rounded-circle me-3 mb-0">
                                                            <img 
                                                                src={speaker.image ? `${process.env.REACT_APP_FILE_BASE_URL}/uploads/profile/${speaker.image}` : "/assets/img/user1.jpg"} 
                                                                alt="" 
                                                            />
                                                        </figure>
                                                        <div>
                                                            <p className="size-12 mb-0 fw-bold">{speaker.name} ({speaker.title})</p>
                                                            <p className="size-10 text-muted mb-0">{speaker.subject}</p>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    )}

                                    <div className="d-flex justify-content-between align-items-center mt-3 pt-3 border-top">
                                        <span className="size-12 text-muted">دبیر برنامه: {item.secretary}</span>
                                        {item.registrationLink && (
                                            <a 
                                                href={item.registrationLink} 
                                                target="_blank" 
                                                rel="noopener noreferrer" 
                                                className="btn btn-sm btn-default btn-rounded px-3"
                                            >
                                                ثبت نام <LinkIcon sx={{ fontSize: 14 }} />
                                            </a>
                                        )}
                                    </div>
                                </div>
                            </div>
                        ))
                    )}
                </div>
            </div>
        </div>
    );
};

export default Retraining;
